require("!!/Users/fabian/Sites/sun/node_modules/script-loader/addScript.js")(require("!!/Users/fabian/Sites/sun/node_modules/raw-loader/index.js!/Users/fabian/Sites/sun/node_modules/chart.js/dist/Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chart.js/dist/Chart.min.js
// module id = 185
// module chunks = 10